import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["objectFit", "priority", "loading", "decoding"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import * as styles from './Image.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = function Image(_ref) {
  var objectFit = _ref.objectFit,
      priority = _ref.priority,
      _ref$loading = _ref.loading,
      loadingDeprecated = _ref$loading === void 0 ? 'lazy' : _ref$loading,
      _ref$decoding = _ref.decoding,
      decodingDeprecated = _ref$decoding === void 0 ? 'async' : _ref$decoding,
      sharedProps = _objectWithoutProperties(_ref, _excluded);

  var loading = loadingDeprecated;
  var decoding = decodingDeprecated;

  if (priority) {
    loading = null;
    decoding = null;
  }

  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, sharedProps), {}, {
    className: classNames(styles['container'], _defineProperty({}, styles['container--contain'], objectFit === 'contain')),
    loading: loading || undefined,
    decoding: decoding || undefined // @ts-expect-error Используемая версия TS ничего не знает об этом свойстве
    ,
    fetchpriority: priority ? 'high' : undefined
  }));
};